// extracted by mini-css-extract-plugin
module.exports = {"prose":"prose_prose__y0zpl","small":"prose_small__gfPa2","center":"prose_center__hhZgn","left":"prose_left__A7Bs8","right":"prose_right__Cs8f5"};